<div>
  <!-- <h1 class="typography--display1">Job Status Detail</h1> -->
  <h2 class="typography--headline">{{ jobName }}</h2>
  <dl class="definitions--inline">
    <dt>ID</dt>
    <dd>{{ id }}</dd>
  </dl>
</div>
